module.exports = __webpack_public_path__ + "img/antes_despues_17.49eaad38.png";